<template>
  <div>
    <el-tabs v-model="activeName">
      <!-- 待申诉、申诉中、申诉完成 -->
      <el-tab-pane label="待申诉" name="1">
        <abnormalTable v-if="activeName === '1'" :inAppealStatus="'1,4'" />
      </el-tab-pane>
      <el-tab-pane label="申诉中" name="2">
        <abnormalTable v-if="activeName === '2'" :inAppealStatus="'2'" />
      </el-tab-pane>
      <el-tab-pane label="申诉完成" name="3">
        <abnormalTable v-if="activeName === '3'" :inAppealStatus="'3,5'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import abnormalTable from "./abnormalTable.vue";
export default {
  name: "AbnormalWaybill",
  components: {
    abnormalTable
  },
  data() {
    return {
      activeName: "1"
    };
  }
};
</script>
<style scoped></style>
